export default class DownloadsComponent {
	constructor() {

		let tabLinks = document.querySelectorAll(".tabs .tab");

		tabLinks.forEach(function (tabLink) {
			tabLink.addEventListener("click", function () {
				let thisBlock = this.closest(".downloads-blocks");
				let targetClick = this.dataset.tab;
				let tabLinkActive = thisBlock.querySelector(".tabs .tab.active");

				let tabActive = thisBlock.querySelector(".contents-tab.active");
				let tabContent = document.getElementById(targetClick);

				tabActive.classList.remove("active");
				tabLinkActive.classList.remove("active");

				tabContent.classList.add("active");
				this.classList.add("active");
			})
		})

		let contentsTab = document.querySelectorAll(".downloads-blocks .contents-tab");

		contentsTab.forEach(function (contentTab) {
			let blocks = contentTab.querySelectorAll(".download-box");

			if (blocks.length > 5) {
				contentTab.classList.add("collapse");
			}

			contentTab.querySelector(".show-more").addEventListener("click", function () {
				contentTab.classList.remove('collapse');
			})
		})
	}
}
new DownloadsComponent();